import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Businessmarketing() {
  return (
    <section
      className="business_marketing p-100"
      style={{ backgroundColor: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Why Choose TekRevol as Your <span>CMS Development</span> Company
            </h2>
            <p style={{ color: "#898989" }}>
              Choose TekRevol for your CMS development to gain a competitive
              edge with a solution that scales seamlessly with your business.
              Our expert team builds CMS that offers real-time content updates,
              integrates advanced features, and ensures robust security.
            </p>
            <p style={{ color: "#898989" }}>
              We focus on creating sustainable, future-proof CMS platforms that
              adapt to your unique needs, optimizing performance and user
              experience. Experience tailored support and innovative solutions
              designed to enhance your digital presence, streamline content
              management, and drive significant growth. Let TekRevol transform
              your CMS into a powerful tool for achieving your business
              objectives.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={5}
            xxl={6}
            className="text-center offfset-xl-1"
          >
            <StaticImage
              src="../../images/services-usa/cms-development/why_choose_cms.webp"
              alt="tekrevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={528}
              height={706}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Businessmarketing;
